{
  "Title": "Manage Queues",
  "ManageQueuesDescriptionTitle": "Description",
  "ManageQueuesCQConfigurationsTitle": "CQ Configurations",
  "ManageQueuesResourceAccountsTitle": "Resource Accounts",
  "ManageQueuesMonitoringStatusTitle": "Monitoring Status",
  "ManageQueueFiltersTitle": "Filters",
  "ManageQueueCallMonitoringHistoric": "Historic",
  "ManageQueueCallMonitoringRealTime": "Real-Time",
  "ManageQueueCallMonitoringRealTimeForced": "Real-Time (Forced)",
  "ManageQueueCallMonitoringUnknown": "Unknown",
  "ManageQueueCallCQConfigurationCompatible": "Compatible",
  "ManageQueueCallCQConfigurationIncompatible": "Incompatible",
  "ManageQueuesQueueFilterAll": "All Queues",
  "ManageQueuesFilterCompatible": "Compatible Queues",
  "ManageQueuesFilterIncompatible": "Incompatible Queues",
  "ManageQueue_DisableEnableRealtime_Confirm": "Confirm",
  "ManageQueue_DisableEnableRealtime_Cancel": "Cancel",
  "ManageQueue_MonitorAllMessage": "Are you sure you want to enable real-time monitoring for all queues?",
  "ManageQueue_UnmonitorAllMessage": "Are you sure you want to disable real-time monitoring for all queues?",
  "ManageQueue_Loading_Monitoring_All": "Enabling real-time monitoring for all queues",
  "ManageQueue_Loading_Unmonitoring_All": "Disabling real-time monitoring for all queues",
  "ManageQueue_Pending_Queue_Disabling": "Disabling monitoring...",
  "ManageQueue_Pending_Queue_Enabling": "Enabling monitoring...",
  "ManageQueue_Disable_RT_Popper": "Disable Real-Time monitoring on all Queues",
  "ManageQueue_Enable_RT_Popper": "Enable Real-Time monitoring on all Queues",
  "ManageQueues_Not_Found_Error": "No queues matching that search were found",
  "NAME": "ManageQueues"
}